module.exports = __webpack_public_path__ + "img/message.52a9843c.png";